import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import type { MapPoint } from '../../data/dashboard';
import { toBn } from '../../utils/bn';
interface DhakaMapProps {
  points: MapPoint[];
  height?: number;
}
export function DhakaMap({
  points,
  height = 340
}: DhakaMapProps) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    const map = L.map(ref.current, {
      zoomControl: true,
      scrollWheelZoom: false,
      attributionControl: true
    }).setView([23.783, 90.395], 12);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; OpenStreetMap, &copy; CARTO',
      maxZoom: 18
    }).addTo(map);
    points.forEach(p => {
      const color = p.issues >= 3 ? '#c62828' : p.issues >= 2 ? '#e08a00' : '#006a4e';
      L.circleMarker([p.lat, p.lng], {
        radius: 6 + p.scans / 12,
        color,
        weight: 2,
        fillColor: color,
        fillOpacity: 0.35
      }).bindTooltip(`<div style="font-size:12px"><b>${p.name}</b><br/>স্ক্যান: ${toBn(p.scans)} • অনিয়ম: ${toBn(p.issues)}</div>`, {
        direction: 'top'
      }).addTo(map);
    });
    return () => {
      map.remove();
    };
  }, [points]);
  return <div className="relative" data-id="element-699" data-mp="4j2vd4agnoq5">
      <div ref={ref} style={{
      height
    }} className="z-0 w-full overflow-hidden rounded-md border border-border" data-id="element-700" data-mp="4k42wys9pt34" />
      <div className="pointer-events-none absolute bottom-2 left-2 z-[400] flex gap-3 rounded-md border border-border bg-white/95 px-3 py-1.5 text-[11px] text-slate-600 shadow-sm" data-id="element-701" data-mp="125jkvncycy1c">
        <span className="flex items-center gap-1" data-id="element-702" data-mp="sf72o1sm1gyd"><span className="h-2 w-2 rounded-full bg-bdgreen-600" data-id="element-703" data-mp="nhf2kkhtaoj3" />স্বাভাবিক</span>
        <span className="flex items-center gap-1" data-id="element-704" data-mp="nfcfa881n9i2"><span className="h-2 w-2 rounded-full bg-amber-500" data-id="element-705" data-mp="1kxci5tz215ev" />সতর্কতা</span>
        <span className="flex items-center gap-1" data-id="element-706" data-mp="1g62tavlby641"><span className="h-2 w-2 rounded-full bg-red-600" data-id="element-707" data-mp="1g51gomoo1bk7" />উচ্চ অনিয়ম</span>
      </div>
    </div>;
}